import { z } from "zod";

export const SignInSchema = z.object({
  email: z
    .string({ message: "Please enter your email address" })
    .email({ message: "Please enter a valid email address" }),
  password: z
    .string({ message: "Please enter your password" })
    .min(6, { message: "Please enter a valid password" })
    .max(128),
});

export const SignUpSchema = z.object({
  name: z.string({ message: "Please enter your first name" }),
  lastName: z.string({ message: "Please enter your last name" }),
  email: z
    .string({ message: "Please enter your email address" })
    .email({ message: "Please enter a valid email address" }),
  password: z
    .string({ message: "Please enter your password" })
    .min(6, { message: "Please enter a valid password" })
    .max(128),
});

export const ForgotPasswordSchema = z.object({
  email: z
    .string({ message: "Please enter your email address" })
    .email({ message: "Please enter a valid email address" }),
});

export const ResetPasswordSchema = z
  .object({
    resetToken: z.string(),
    password: z
      .string({ message: "Please enter a new password" })
      .min(6, { message: "Please enter a valid password" })
      .max(128),
    passwordConfirmation: z
      .string({ message: "Please confirm your new password" })
      .min(6, { message: "Please enter a valid password" })
      .max(128),
  })
  .refine((data) => data.password === data.passwordConfirmation, {
    path: ["passwordConfirmation"],
    message: "Passwords do not match",
  });

export const MfaVerificationSchema = z
  .string({
    message: "Please enter the verification code sent to your phone number",
  })
  .regex(/^\d{6}$/, { message: "Please enter a valid verification code" });

export const MfaEnrollmentSchema = z.string().regex(/^\d{10}$/, {
  message: "Please enter a valid phone number",
});
